import ElementCard from './ElementCard';

export default ElementCard;